<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [showBack]="true"></prox-main>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full">
    <div class="flex mb-2">
      <label class="mt-3">Show submissions after</label>
      <p-datepicker class="ml-2" [(ngModel)]="afterDate" (ngModelChange)="refresh()"></p-datepicker>
      <p-checkbox class="ml-4 mt-2" [(ngModel)]="shouldShowErrorsOnly" [binary]="true" (ngModelChange)="refresh()"
        inputId="shouldShowErrorsOnly"></p-checkbox>
      <label for="shouldShowErrorsOnly" class="ml-2 mt-2">Show Errors Only</label>
      <p-button class="ml-4" size="small" (click)="submitAllPending()" label="Submit All Pending"></p-button>
      <p-button class="ml-4" size="small" (click)="refresh()" label="Refresh"></p-button>
      <p-progressSpinner class="ml-4" *ngIf="isBusy()" ariaLabel="loading"
        [style]="{ width: '30px', height: '30px' }" />
    </div>
    <div class="grow mt-2">
      <prox-ag-grid [gridOptions]="ssGridOptions" [rowData]="supplierSubmissions"></prox-ag-grid>
    </div>
  </div>

</ng-template>